// publish on
export const PAYMENT_ORDER_PARAMETERS = 'payment_order_parameters';
export const CONTINUE_CHECKOUT_MAKE_PAYMENT = 'continue_checkout_make_payment';
export const INITIATE_CHECKOUT = 'initiate_checkout';
export const END_CHECKOUT = 'end_checkout';
export const INITIALIZE_KIT = 'initialize_kit';
export const CLEAR_KIT_PAYMENT_STATE = 'clear_payment_state';

// subscribe to
export const VALIDATION_STATUS = 'validation_status';
export const WIDGET_STATUS = 'widget_on_load';
export const ZPAYKIT_ERROR = 'zpaykit_error';
export const CONTINUE_CHECKOUT_PLACE_ORDER = 'continue_checkout_place_order';
export const INTERNAL_CHECKOUT_CLICKED = 'internal_checkout_clicked';
export const UPI_PAYMENT_IN_PROGRESS = 'upi_payment_in_progress';
